import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedSelect = _resolveComponent("SharedSelect")!
  const _component_UITextArea = _resolveComponent("UITextArea")!
  const _component_SharedInputCurrency = _resolveComponent("SharedInputCurrency")!
  const _component_AdminApplicationBankRequisites = _resolveComponent("AdminApplicationBankRequisites")!
  const _component_UIButton = _resolveComponent("UIButton")!
  const _component_SharedWindow = _resolveComponent("SharedWindow")!

  return (_openBlock(), _createBlock(_component_SharedWindow, {
    class: _normalizeClass(_ctx.b()),
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('wrapper'))
      }, [
        _createElementVNode("h3", {
          class: _normalizeClass(_ctx.b('title'))
        }, _toDisplayString(_ctx.activeTab === "edit" ? "Редактирование заявки" : "Реквизиты заявки"), 3),
        (_ctx.adminDepositWithdrawalShow.bank_requisite)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.b('tabs'))
            }, [
              _createElementVNode("button", {
                class: _normalizeClass(_ctx.b('tab', { active: _ctx.activeTab === 'edit' })),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleTab('edit')))
              }, " Редактирование ", 2),
              _createElementVNode("button", {
                class: _normalizeClass(_ctx.b('tab', { active: _ctx.activeTab === 'requisites' })),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleTab('requisites')))
              }, " Реквизиты ", 2)
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 'edit')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.b('field'))
              }, [
                _createElementVNode("h4", {
                  class: _normalizeClass(_ctx.b('field-title'))
                }, "Статус", 2),
                _createVNode(_component_SharedSelect, {
                  view: "light",
                  options: _ctx.displayedStatusOptions,
                  value: _ctx.adminDepositWithdrawalShow.status,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.adminDepositWithdrawalShow.status) = $event))
                }, null, 8, ["options", "value"])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.b('field'))
              }, [
                _createElementVNode("h4", {
                  class: _normalizeClass(_ctx.b('field-title'))
                }, " Этап (Добавляте этапы построчно используя Enter) ", 2),
                _createVNode(_component_UITextArea, {
                  view: "light",
                  rows: "4",
                  placeholder: "Добавьте комментарий при необходимости",
                  modelValue: _ctx.adminDepositWithdrawalShow.stage,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.adminDepositWithdrawalShow.stage) = $event))
                }, null, 8, ["modelValue"])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.b('field'))
              }, [
                _createElementVNode("h4", {
                  class: _normalizeClass(_ctx.b('field-title'))
                }, "Изменить сумму сделки", 2),
                _createVNode(_component_SharedInputCurrency, {
                  placeholder: "Введите новую сумму",
                  value: _ctx.adminDepositWithdrawalShow.amount,
                  currency: _ctx.adminDepositWithdrawalShow.currency,
                  "onUpdate:value": _ctx.handleAmount
                }, null, 8, ["value", "currency", "onUpdate:value"]),
                _createElementVNode("p", null, "Пользователь получит: " + _toDisplayString(_ctx.displaedUserAmount), 1)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.b('field'))
              }, [
                _createElementVNode("h4", {
                  class: _normalizeClass(_ctx.b('field-title'))
                }, "Изменить объем сделки", 2),
                _createVNode(_component_SharedInputCurrency, {
                  placeholder: "Введите новую сумму",
                  value: _ctx.adminDepositWithdrawalShow.transaction_volume,
                  currency: _ctx.adminDepositWithdrawalShow.currency,
                  "onUpdate:value": _ctx.handleTransactionVolume
                }, null, 8, ["value", "currency", "onUpdate:value"])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.b('field'))
              }, [
                _createElementVNode("h4", {
                  class: _normalizeClass(_ctx.b('field-title'))
                }, "Изменить цену исполнения", 2),
                _createVNode(_component_SharedInputCurrency, {
                  placeholder: "Введите новую сумму",
                  value: _ctx.adminDepositWithdrawalShow.execution_price,
                  currency: _ctx.adminDepositWithdrawalShow.currency,
                  "onUpdate:value": _ctx.handleExecutionPrice
                }, null, 8, ["value", "currency", "onUpdate:value"])
              ], 2)
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('fields'))
        }, [
          _withDirectives(_createVNode(_component_AdminApplicationBankRequisites, {
            "bank-requisite": _ctx.adminDepositWithdrawalShow.bank_requisite
          }, null, 8, ["bank-requisite"]), [
            [_vShow, 
            _ctx.activeTab === 'requisites' &&
            _ctx.adminDepositWithdrawalShow.bank_requisite
          ]
          ])
        ], 2),
        (_ctx.activeTab === 'edit')
          ? (_openBlock(), _createBlock(_component_UIButton, {
              key: 2,
              label: "Сохранить",
              view: "main",
              disabled: _ctx.isDisabled,
              onClick: _ctx.handleSave
            }, null, 8, ["disabled", "onClick"]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1
  }, 8, ["class", "onClose"]))
}